// extracted by mini-css-extract-plugin
export default {"BooksPage":"BooksPage-module--BooksPage--2jJRg"};